import { render, staticRenderFns } from "./UsersPrivilegeServicesReservationEmployeeBenefit.vue?vue&type=template&id=ef2e2caa&scoped=true&"
import script from "./UsersPrivilegeServicesReservationEmployeeBenefit.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeServicesReservationEmployeeBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2e2caa",
  null
  
)

export default component.exports